<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <!-- <router-link
        class="profile-link"
        active-class
        :exact="true"
        :to="{name: 'AddStudentCatchUp'}"
      >
        <v-btn color="#6A158E" dark>+ Add Catchup Session</v-btn>
      </router-link> -->

      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <Form></Form>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import Form from "../../../components/StudentPanel/admission/Form.vue";

export default {
  name: "AdmissionForm",
  components: { Form, BreadCrumbs },
  data() {
    return {
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>